<div class="form-wrapper">
  <p-dropdown
    #dropdown
    [placeholder]="state?.name"
    class="dropdown-full-width"
    [name]="field.field"
    [options]="options"
    [panelStyle]="{ 'max-width': '250px' }"
    [style]="{ width: '100%' }"
    (onChange)="onTransitionSelected($event)"
    appendTo="body"
  >
    <ng-template let-item pTemplate="item">
      <i
        [class]="item.value.stateIcon"
        [ngStyle]="{ color: item.value.stateColor }"
        [pTooltip]="item.value.stateDescription"
        class="state-icon"
      ></i>
      {{ item.label }}
    </ng-template>
  </p-dropdown>
  <button pButton type="button" tabindex="-1" (click)="nullField()" icon="pi pi-times"></button>
</div>
